import { createFileRoute } from "@tanstack/react-router";

import { findAreaBySlug } from "@/data/local-areas";
import { routeHead } from "@/lib/seo-head";
import LocalAreaPage from "@/pages/LocalAreaPage";

export const Route = createFileRoute("/architecte-interieur-sainte-foy-les-lyon")({
  head: () => {
    const area = findAreaBySlug("architecte-interieur-sainte-foy-les-lyon");
    return routeHead({
      path: "/architecte-interieur-sainte-foy-les-lyon",
      title: `Architecte d'intérieur ${area?.city ?? "Lyon"} | JIIA Studio`,
      description: area?.intro ?? "",
    });
  },
  component: LocalAreaPage,
});
